var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseModal = function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.175 6 3.583-3.575a.836.836 0 1 0-1.183-1.183L6 4.825 2.425 1.242a.837.837 0 1 0-1.183 1.183L4.825 6 1.242 9.575a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.183 0L6 7.175l3.575 3.583a.833.833 0 0 0 1.183 0 .832.832 0 0 0 0-1.183L7.175 6Z"
  })));
};
export default SvgCloseModal;